'use client'
import { use, useEffect, useState } from "react"
import Cookies from "js-cookie"
import { sendGTMEvent } from '@next/third-parties/google'
import useOnLoadListener from "./useOnLoadListener"

interface DatalayerPageViewProps {
  hostname: string;
  locale: string;
  slug: string;
  siteName: string;
  environment: string;
}

export const DatalayerPageView = ({
  hostname, 
  locale, 
  slug, 
  siteName, 
  environment
}: DatalayerPageViewProps) => {

  const datalayerPageViewManager = () => {
    let lang = locale || ""
    let country = null
    // let user_id = Cookies.get("_ga")
    let marketo_id = Cookies.get("_mkto_trk")
    let business_id = Cookies.get("_biz_uid")
    let contentful_id = Cookies.get("contentful_id")
    let franchise_name = null
    let division_name = null
    let subdivision_name = null

    franchise_name = (document.querySelector('meta[name="franchise"]') as HTMLMetaElement | null)?.content
    if (franchise_name === "undefined") {
      franchise_name = null
    }
    division_name = (document.querySelector('meta[name="division"]') as HTMLMetaElement | null)?.content
    if (division_name === "undefined") {
      division_name = null
    }
    subdivision_name = (document.querySelector(
      'meta[name="subdivision"]'
    ) as HTMLMetaElement | null)?.content
    if (subdivision_name === "undefined") {
      subdivision_name = null
    }
    Cookies.set("prev_page", window.location.pathname)

    if (window.dataLayer && Array.isArray(window.dataLayer)) {
      sendGTMEvent({
        event: "dataLayer-initialized", // This is just Page View
        page_url: window.location.href, // slug is not the full URL, so I need to use window.location.href
        page_title: siteName,
        locale: locale,
        spa_page: null,
        content_category: null,
        franchise: franchise_name, // Needs work before sectors
        division: division_name, // Needs work before sectors
        subdivision: subdivision_name, // Needs work before sectors
        business_id: business_id, // taking a guess here
        marketo_id: marketo_id,
        contentful_id: contentful_id,
        salesforce_id: null, // Don't think this is tracked
        amplitude_id: null, // Don't think this is tracked
        language: lang,
        site_version: null, // I need a <meta tag>
        environment: environment, // I'd prefer a <meta tag> but it's fine
        hostname: hostname,
        luna_version: null, // I need a <meta tag>
        // User is not something the site tracks currently
        trimble_id: localStorage.getItem("user_info")
          ? JSON.parse(localStorage?.getItem("user_info") || "")?.tid
          : null,
        user_id: null,
        user_type: null,
        user_preferences: null,
        user_purchase_history: null,
        entitlement_id: null,
        entitlement_status: null,
        partner_type: null, // Don't know what this is
        dealer_type: null, // Don't know what this is
        member_since: null, // Don't know what this is
        logged_in: localStorage.getItem("user_info") ? true : false,
        // I don't think this data is avaliable at this component level? Maybe it's in state?
        city: null, // Don't think this is tracked
        state: null, // Don't think this is tracked
        country: country,
        postal_code: null, // Don't think this is tracked
      })
    }
  }
  useOnLoadListener(datalayerPageViewManager)

  return (<div className="datalayer-gtm-page-view hidden hide"></div>)
}

export default DatalayerPageView
